export default __webpack_public_path__ + "static/media/2021-11_Sean-Marjason-personal-website.93f2af8c.jpg";